const PaymentPageFooter = () => {
  return (
    <div className="payment-page-footer">
      <div className="footer-brand">
        <svg
          width="16"
          height="16"
          viewBox="0 0 14 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11 8V5C11 2.79 9.21 1 7 1C4.79 1 3 2.79 3 5V8"
            stroke="rgba(255,255,255,0.8)"
            strokeWidth="1.8"
            strokeLinecap="round"
          />
          <rect
            x="1"
            y="8"
            width="12"
            height="9"
            rx="2"
            stroke="rgba(255,255,255,0.8)"
            strokeWidth="1.8"
          />
          <circle cx="7" cy="12.5" r="1.5" fill="rgba(255,255,255,0.8)" />
        </svg>
        <span className="footer-secured-text">Secured by</span>
        <img
          src="/images/monnify-by-teamapt-logo.svg"
          alt="monnify"
          className="footer-monnify-logo"
        />
      </div>
      <div className="footer-separator" />
      <div className="footer-card-logos">
        <img src="/images/logo-visa.svg" alt="Visa" />
        <img src="/images/logo-mastercard.svg" alt="Mastercard" />
        <img src="/images/logo-verve.svg" alt="Verve" />
      </div>
    </div>
  );
};

export default PaymentPageFooter;
